import JSXComponent from "../../../dist/jsx-render/JSXComponent";
import dom from "../../../dist/jsx-render/dom";
import { ITreeField } from "./ITreeField";
import { TextComponent } from "../../Components/TextComponent";

export type AvailableTreeFieldComponentProps = {
    model: ITreeField;
}

export class AvailableTreeFieldComponent extends JSXComponent {
    private props: AvailableTreeFieldComponentProps;

    constructor(props: AvailableTreeFieldComponentProps) {
        super(props);
    }

    element: HTMLElement =
        <div className="tree-item">
            {this.props.model.name}
        </div>

    render() {
        return this.element;
    }
}